import { render, staticRenderFns } from "./ComplementaInformacion.vue?vue&type=template&id=ec249e5a"
import script from "./ComplementaInformacion.vue?vue&type=script&lang=js"
export * from "./ComplementaInformacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec249e5a')) {
      api.createRecord('ec249e5a', component.options)
    } else {
      api.reload('ec249e5a', component.options)
    }
    module.hot.accept("./ComplementaInformacion.vue?vue&type=template&id=ec249e5a", function () {
      api.rerender('ec249e5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/ratificaciones/ComplementaInformacion.vue"
export default component.exports